const STORAGE_KEY = 'cgt_pending_toast'

export function storePendingToast({ type = 'success', message }) {
  if (typeof window === 'undefined' || !window.sessionStorage || !message) return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ type, message }))
  } catch (_) { /* quota / privacy mode — silently skip */ }
}

export function consumePendingToast() {
  if (typeof window === 'undefined' || !window.sessionStorage) return
  const raw = window.sessionStorage.getItem(STORAGE_KEY)
  if (!raw) return
  window.sessionStorage.removeItem(STORAGE_KEY)
  try {
    const { type, message } = JSON.parse(raw)
    if (typeof window.showNotification === 'function' && message) {
      window.showNotification(message, { type: type || 'success', autohide: true })
    }
  } catch (_) { /* malformed payload — ignore */ }
}
